// extracted by mini-css-extract-plugin
export default {"AuditorCommentsPill":"AuditorCommentsPill_AuditorCommentsPill__1pKTJ","gradient":"AuditorCommentsPill_gradient__VI582","Solid":"AuditorCommentsPill_Solid__6ay+r"};